import * as XLSX from 'xlsx';

/**
 * Builds the `{ blob, filename }` that ExportModal's `onExport` must resolve to.
 *
 * Shared by the detail-page tabs, which export the rows they already hold in
 * memory. (The list screens refetch the full server-side page set first, then
 * feed the result through the same shape.)
 */
/**
 * Money cell for exports: a plain number (0 kept) so Excel can sum it, with
 * the currency in its own column. Missing/non-numeric values become ''.
 */
export function exportAmount(value) {
	if (value === null || value === undefined || value === '') return '';
	const amount = Number(value);
	return Number.isFinite(amount) ? amount : '';
}

export function buildXlsxExport({ rows, fields, selectedKeys, getters, sheetName, filePrefix }) {
	// Column order follows the field catalog, not the order the user ticked boxes.
	const orderedFields = fields.filter((field) => selectedKeys.includes(field.key));
	const data = rows.map((row) =>
		Object.fromEntries(orderedFields.map((field) => [field.label, getters[field.key](row)])),
	);
	// `header` keeps the column order even when the first row has blank cells,
	// which json_to_sheet would otherwise drop from the sheet's key set.
	const worksheet = XLSX.utils.json_to_sheet(data, { header: orderedFields.map((field) => field.label) });
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
	const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
	return {
		blob: new Blob([buffer], { type: 'application/octet-stream' }),
		filename: `${filePrefix}_${new Date().toISOString().slice(0, 10)}.xlsx`,
	};
}

export default buildXlsxExport;
